module.exports = __webpack_public_path__ + "static/media/SourceSansPro-ExtraLightIt.43475fb6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-ExtraLightIt.svg
// module id = 323
// module chunks = 3